import 'core-js/actual';
import 'regenerator-runtime/runtime';
import 'utils/Url';
import 'whatwg-fetch';
import 'performance-polyfill';
import runApplication from 'utils/framework/main';

runApplication();
